@if(!ready){<lib-spinner-overlay></lib-spinner-overlay>}
@else{
<lib-webheader2 (Logout)="appService.logout()" (Login)=login() [showHamburger]="this.appService.CurrentUser != null"
  [loggedIn]="this.appService.CurrentUser != null" [withRegistration]="false" [withmandant]="false" showLanguage="false"
  (MenuButtonClick)="sidenav.toggle()">
  @if(this.appService.CurrentUser){
  <button mat-icon-button toolbar routerLink="/todos">
    <mat-icon [matBadge]="todosCount" matBadgePosition="above after" matBadgeColor="accent">Check</mat-icon>
  </button>
  }
</lib-webheader2>

<app-sidenav #sidenav>
  @if(this.appService.CurrentUser){
  <router-outlet></router-outlet>
  }@else {
  <app-start-view></app-start-view>
  }
</app-sidenav>

<lib-webfooter></lib-webfooter>
}